import { Maybe } from 'src/models/general.model';
import { AttributeChange } from 'src/models';

export interface AttributeChangesState {
  attributeChanges?: Maybe<AttributeChange[]>;
}

export const INITIAL_ATTRIBUTE_CHANGES_STATE: AttributeChangesState = {};
